import { API_BASE } from './client';

export async function submitContactMessage({ name, email, phone, message }) {
  const response = await fetch(`${API_BASE}/messages`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name, email, phone: phone || undefined, message }),
  });

  const payload = await response.json().catch(() => null);

  if (!response.ok) {
    const errorMessage =
      payload?.message ||
      (payload?.errors && Object.values(payload.errors).flat().join(' ')) ||
      `Request failed (${response.status})`;
    throw new Error(errorMessage);
  }

  return payload;
}
